export const States = {
    claims: [],
    token: localStorage.getItem("token") ? localStorage.getItem("token"): '',
    lastTimestamp: 0,
}
